import { CONSENT_STORAGE_KEY, ConsentSelection, CookieConsent, createConsent, isCookieConsent } from "./consentTypes"

export function readStoredConsent(): CookieConsent | null {
    if (typeof window === "undefined") {
        return null
    }

    try {
        const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY)
        if (!raw) {
            return null
        }

        const parsed = JSON.parse(raw)
        return isCookieConsent(parsed) ? parsed : null
    } catch {
        return null
    }
}

export function storeConsent(selection: ConsentSelection): CookieConsent {
    const consent = createConsent(selection)
    if (typeof window !== "undefined") {
        window.localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(consent))
    }
    return consent
}

export function clearStoredConsent(): void {
    if (typeof window === "undefined") {
        return
    }

    window.localStorage.removeItem(CONSENT_STORAGE_KEY)
}
